import React from 'react';
import { View, StyleSheet } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import RadioButton from 'design-system/RadioButton';
import { formatPlural } from 'utils';
import useColors from 'hooks/useColors';
import MerchantLogo from './MerchantLogo';
import { isWeb } from '../../../../constants';
const KeyboardMerchantsRow = ({ item, onPress, isSelected, type }) => {
    const colors = useColors();
    if (!item) {
        return null;
    }
    return (<TouchableHighlight onCard hoverOnLight activeOpacity={1} onPress={onPress} underlayColor={colors.background.underlay}>
      <View style={styles.container}>
        <RadioButton isChecked={isSelected} type={type}/>
        <Spacer w={16}/>
        <MerchantLogo data={item}/>
        <Spacer w={16}/>
        <View style={styles.main}>
          <Text Text-16 numberOfLines={1}>
            {item.displayName}
          </Text>
          {typeof item.transactionsCount === 'number' && (<Text TextThin-14 Secondary>
              {item.transactionsCount} {formatPlural('transaction', 'transactions', item.transactionsCount)}
            </Text>)}
        </View>
      </View>
    </TouchableHighlight>);
};
const styles = StyleSheet.create({
    container: {
        paddingVertical: rem(16),
        paddingHorizontal: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
        ...(isWeb && {
            paddingHorizontal: 8,
        }),
    },
    main: {
        flex: 1,
        justifyContent: 'center',
    },
});
export default KeyboardMerchantsRow;
